
    
import handlePayment from "@/services/modules/payment";
import handleContra from "@/services/modules/contra";
import handleReceipt from "@/services/modules/receipt";
import handleJournal from "@/services/modules/journal"; 
import handleCompany from "@/services/modules/company";
import ngoPdfPrinter from '@/services/utils/ngoPdfPrinter';
import handleBarcode from "@/services/modules/barcode";

import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";



export const useVoucherPrint = () => {
    const { fetchCompanyInfo, fetchActiveCustomizationField } = handleCompany();
    const {fetchSinglePayment} = handlePayment();
    const { fetchSingleContra } = handleContra();
    const { fetchSingleReceipt } = handleReceipt();
    const { fetchJournal } = handleJournal();
    const { exportToPDF } = ngoPdfPrinter();
    const { fetchBarcode } = handleBarcode();
    
    const route = useRoute();
    const router = useRouter();
    const companyInfo = ref({});
    const payment = ref({});
    const barcodeQuery = ref('')
    const barcode = ref('')
    const qrcode = ref('');
    const voucherInfo = ref({});

    const vouchers = {
        contra_voucher: {
            name: "CONTRA VOUCHER",
            route: "np-contra-voucher-edit",
            idParams: "contraId",
            pdfType: "contra",
            vMethod: fetchSingleContra,
        },
        journal_voucher: {
            name: "JOURNAL VOUCHER",
            route: "edit-journal-np",
            idParams: "journalId",
            pdfType: "journal",
            vMethod: fetchJournal
        },
        payment_voucher: {
            name: "PAYMENT VOUCHER",
            route: "ngo-payment-voucher-edit",
            idParams: "paymentId",
            pdfType: "payment",
            vMethod: fetchSinglePayment
        },
        receipt_voucher: {
            name: "RECEIPT VOUCHER",
            route: "receipt-voucher-np-edit",
            idParams: "receiptId",
            pdfType: "receipt",
            vMethod: fetchSingleReceipt
        },
    }


    const getType = (voucherNo) => {
        const prefix = voucherNo.substring(0, 2);
        switch (prefix) {
            case 'CV':
                return 'contra_voucher';
            case 'JV':
                return 'journal_voucher';
            case 'PV':
                return 'payment_voucher';
            case 'RV':
                return 'receipt_voucher'
        }
    }
    
    fetchCompanyInfo(route.params.companyId).then( (res) => {
            companyInfo.value = res.data;
        }).catch( (err) => {
            console.log(err);
    })

    const printVoucher = (id, type) => {

        const fetchVoucherByType = vouchers[type].vMethod;
        const companyQuery = `?company_id=${route.params.companyId}`;
        const pdfType = vouchers[type].pdfType;
        const customizationType = `${pdfType}_voucher_pdf`;
        const customizationQuery = `?company_id=${route.params.companyId}&customization_type=pdf&type=${customizationType}`;

        let customizationFields = [];

        Promise.all([
            fetchVoucherByType(id, companyQuery),
            fetchActiveCustomizationField(customizationQuery)
        ]).then(([voucherRes, customizationRes]) => {
            if(voucherRes){
                voucherInfo.value = voucherRes.data;
                const qrcodeData = buildQrcodeText(voucherInfo.value);
                barcodeQuery.value = `?code=${encodeURIComponent(voucherInfo.value.voucher_no)}&qrcode=${encodeURIComponent(qrcodeData)}`;
            }
            if(customizationRes){
                customizationFields = customizationRes.data;
            }
        }).then (() => {
            fetchBarcode(barcodeQuery.value).then( (res) => {
                barcode.value = res.barcode;
                qrcode.value = res.qrcode;
            }).then( () => {
                exportToPDF(companyInfo.value, voucherInfo.value, barcode.value, qrcode.value, pdfType, customizationFields);
            })}).catch((err) => {
            console.log(err);
        })
    }

    const buildQrcodeText = (voucher) => {
        const createdBy = voucher.user ? voucher.user.name : 'N/A';
        const createdAt = voucher.formatted_created_at ? voucher.formatted_created_at : 'N/A';
        const updatedAt = voucher.formatted_updated_at ? voucher.formatted_updated_at : 'N/A';
        return [
            `Voucher No : ${voucher.voucher_no}`,
            `Voucher Date: ${formatToDdMmYy(voucher.date)}`,
            `Created By : ${createdBy}`,
            `Created Date & Time: ${createdAt}`,
            `Updated Date & Time: ${updatedAt}`
        ].join('\n');
    }

    const formatToDdMmYy = (date) => {
        if (!date) return '';
        const dat = date.split('-');
        return `${dat[2]}-${dat[1]}-${dat[0]}`;
    }

    return {
        printVoucher,
        vouchers,
        getType,
        buildQrcodeText
    }
}